export const ALL_KPIS_VALUE = 'ALL' as const
export const ALL_KPIS_NAME = 'All KPIs'
